const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class QuoteProgressService {
  // Helper method to get auth token from localStorage
  static getAuthToken() {
    return localStorage.getItem("authToken");
  }

  // Save or update a quote step
 static async saveStep({ quoteId, stepName, completed, actions = {} }) {
  const token = this.getAuthToken();

  // Fetch existing progress
 const existingProgressRaw = await fetch(`${API_BASE_URL}/quote-progress/${quoteId}`, {
  headers: { Authorization: `Bearer ${token}` },
}).then(res => res.json());

const existingProgress = Array.isArray(existingProgressRaw) ? existingProgressRaw : [];


if (existingProgress.length > 0) {
  // Only run this if there are existing entries
  const step = existingProgress.find(p => p.step_name === stepName);
  const mergedActions = { ...(step?.actions || {}), ...actions };

  // save or update logic here
} else {
  // Table is empty, handle as a new entry
  const response = await fetch(`${API_BASE_URL}/quote-progress`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      quote_id: quoteId,
      step_name: stepName,
      completed,
      actions, // no previous actions
    }),
  });

  if (!response.ok) throw new Error("Failed to save quote progress");
  return response.json();
}

 }


  // Fetch all progress for a quote
  static async getProgress(quoteId) {
    const token = this.getAuthToken();

    const response = await fetch(`${API_BASE_URL}/quote-progress/${quoteId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch quote progress");
    }

    return response.json();
  }
  static async getProgressBatch(connectionIds = []) {
    if (!connectionIds.length) return {};

    const token = this.getAuthToken();

    // API expects query param: ?connection_ids=1,2,3
    const url = `${API_BASE_URL}/quote-progress?connection_ids=${connectionIds.join(',')}`;

    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!response.ok) throw new Error("Failed to fetch batch quote progress");

    const data = await response.json();

    // Normalize: ensure all requested IDs exist
    const normalized = {};
    connectionIds.forEach(id => {
      normalized[id] = data[id] || [{ step_name: 'initial', completed: false, actions: {}, status: 'Not Started' }];
    });

    return normalized; // { "1": [...], "2": [...] }
  }
}

export default QuoteProgressService;
